import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultComponent } from '../default.component';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { SharedModule } from 'src/app/shared.module';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TicketService } from './services/ticket.service';
import { IndexComponent } from './components/index.component';
import { TicketComponent } from './components/ticket.component';
import { CustomGridModule } from '../custom-grid/custom-grid.module';
import { CreateTicketComponent } from './components/create-ticket.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { TicketGroupComponent } from './components/ticket-group.component';
import { PermissionGuard } from 'src/app/common/permission.guard';
import { PspdfkitModule } from '../pspdfkit/pspdfkit.module';
import { ScreenshotTicketComponent } from './components/screenshot-ticket.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { TicketReportComponent } from './components/ticket-report.component';
import { TicketJiraSyncModalComponent } from './components/ticket-jira-sync-modal/ticket-jira-sync-modal.component';
import {BadgeComponent} from '@progress/kendo-angular-indicators';

const routes: Routes = [
  {
    'path': '',
    'component': DefaultComponent,
    'children': [
      {
        'path': '',
        'component': IndexComponent
      },
      {
        'path': 'view/:id',
        'component': TicketComponent
      },
      {
        'path': 'create',
        'component': CreateTicketComponent
      },
      {
        'path': 'group',
        'component': TicketGroupComponent,
        data :{ permissions : ['READ_TICKET_MANAGEMENT'] },
        'canActivate':[PermissionGuard]
      },
      {
        'path': 'report',
        'component': TicketReportComponent,
        data :{ permissions : ['READ_TICKET_MANAGEMENT'] },
        'canActivate':[PermissionGuard]
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    ButtonModule,
    GridModule,
    ExcelModule,
    DropDownsModule,
    SharedModule,
    LayoutModule,
    InputsModule,
    DateInputsModule,
    LabelModule,
    PopupModule,
    DialogModule,
    CustomGridModule,
    NgxDropzoneModule,
    ButtonsModule,
    WindowModule,
    EditorModule,
    PspdfkitModule,
    TicketJiraSyncModalComponent,
    BadgeComponent
  ],
  declarations: [
    IndexComponent,
    TicketComponent,
    CreateTicketComponent,
    TicketGroupComponent,
    ScreenshotTicketComponent
  ],
  exports: [RouterModule,ScreenshotTicketComponent],
  providers: [
    TicketService
  ]
})
export class TicketModule { }
